module.controller('viewFeeSummaryCtrl', ['$scope', '$http', '$rootScope', '$window', '$stateParams', 'Session', 'accountService', 'baseURI', 'OVERLAY',
    function ($scope, $http, $rootScope, $window, $stateParams, Session, accountService, baseURI, OVERLAY){
        var url = baseURI + 'card/fees';
        $scope.overlay = OVERLAY['member.home.profile/feesummary'];
        $scope.cancel = true;

        var account = accountService.getAccount($stateParams.username);
        var usernameParam = '/?Username=' + account.username;

        /*
        $scope.PreviousMonthName = 'March';
        $scope.PreviousMonthFees = 967; //api response with pennies
        $scope.CurrentMonthFees = 123;  //api response with pennies
        $scope.YTDFees = 1567;          //api response with pennies
        */

        $http.get(url + usernameParam).then(function (resp){
          var data = resp.data;

            $scope.PreviousMonthName = data.Data.PreviousMonthName;
            $scope.PreviousMonthFees = Number.parseFloat(data.Data.PreviousMonthFees)/100;
            $scope.CurrentMonthFees  = Number.parseFloat(data.Data.CurrentMonthFees)/100;
            $scope.YTDFees           = Number.parseFloat(data.Data.YTDFees)/100;
        }).catch(function (error){
            console.log('err', error);
        });
    }]);
